import { DachCountryCode } from 'signup-ui-lego-core/constants/CountryCode';
import { getCountryCode } from '../store/app/selectors';
export const isDACHCountry = state => {
  const country = getCountryCode(state); // @ts-expect-error This will be corrected by TypeScript 5.1

  return Object.values(DachCountryCode).includes(country);
};